module.exports = __webpack_public_path__ + "static/media/login-background.e4e6093b.png";